import clsx from 'clsx';
import { Checkbox } from '../../../../../shared/ui/checkbox/Checkbox';
import styles from '../FiltersPanel.module.css';

export function FilterOption({
  sectionKey,
  optionKey,
  label,
  count,
  checked = false,
  onToggle,
  tone = 'default',
}) {
  const composedKey = `${sectionKey}:${optionKey}`;
  const isExcluded = tone === 'danger' && checked;

  return (
    <label className={clsx(styles.option)}>
      <span className={clsx(styles.optionMain)}>
        <Checkbox
          checked={checked}
          onChange={() => onToggle(composedKey)}
          tone={isExcluded ? 'danger' : 'default'}
        />
        <span className={clsx(styles.optionLabel, isExcluded && styles.optionLabelExcluded)}>
          {label}
        </span>
      </span>
      <span className={clsx(styles.count)}>{count}</span>
    </label>
  );
}
